var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","color":"success"},on:{"click":_vm.showGroupForm}},[_vm._v(" Agregar grupo ")]),_c('TableGroups')],1)}
var staticRenderFns = []

export { render, staticRenderFns }